import { render, staticRenderFns } from "./ezCmsPriceLabs.vue?vue&type=template&id=30af88b8&scoped=true"
import script from "./ezCmsPriceLabs.vue?vue&type=script&lang=js"
export * from "./ezCmsPriceLabs.vue?vue&type=script&lang=js"
import style0 from "./ezCmsPriceLabs.vue?vue&type=style&index=0&id=30af88b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af88b8",
  null
  
)

export default component.exports